var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent3Kg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.323291,0,0,0.323291,7.37531,6.8446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7,20.08C37.34,13.18 31.28,8 24,8C18.22,8 13.2,11.28 10.7,16.08C4.68,16.72 0,21.82 0,28C0,34.62 5.38,40 12,40L38,40C43.52,40 48,35.52 48,30C48,24.72 43.9,20.44 38.7,20.08ZM38,36L12,36C7.58,36 4,32.42 4,28C4,23.58 7.58,20 12,20L13.42,20C14.74,15.38 18.96,12 24,12C30.08,12 35,16.92 35,23L35,24L38,24C41.32,24 44,26.68 44,30C44,33.32 41.32,36 38,36Z",
    style: {
      fillRule: "nonzero"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.919,20L0,20L0,18L4,18C2.9,18 2,17.1 2,16L2,6C2,4.9 2.9,4 4,4L20,4C21.1,4 22,4.9 22,6L22,13.182C21.503,12.832 21.236,12.658 20.625,12.55C20.564,12.242 20.205,11.482 20,11.231L20,6L4,6L4,16L6.396,16C6.449,17.458 6.994,19.407 8.919,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.593,18C23.094,19.125 22.489,19.727 21.766,20L24,20L24,18L23.593,18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent3Kg);
export default __webpack_public_path__ + "static/media/agent3kg.dca2d69de6d837dc268f8d8387a9f747.svg";
export { ForwardRef as ReactComponent };